export default __webpack_public_path__ + "static/media/planet.fe9e5afe.png";